export default __webpack_public_path__ + "static/media/blue-thumb-down.74326941.svg";